import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStackedBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_410_6067)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14 8.40029C14.0003 8.0792 13.8008 7.81469 13.5471 7.80029L4.47416 7.80029C4.21221 7.80029 4 8.06899 4 8.40029C4 8.7316 4.21221 9.00029 4.47416 9.00029L13.5471 9.00029C13.8008 8.9859 14.0003 8.72139 14 8.40029Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4502 13.8007C20.444 13.6348 20.3855 13.4787 20.2875 13.3663C20.1894 13.254 20.0599 13.1946 19.9271 13.2012L4.48306 13.2012C4.21788 13.2012 4.00306 13.4696 4.00306 13.8007C4.00306 14.1317 4.21788 14.4002 4.48306 14.4002L19.9271 14.4002C20.0599 14.4067 20.1894 14.3473 20.2875 14.2351C20.3855 14.1227 20.444 13.9666 20.4502 13.8007L20.4502 13.8007Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1512 16.501C16.1401 16.3299 16.0756 16.1713 15.9714 16.0592C15.8672 15.9471 15.7318 15.8908 15.5945 15.9024L4.48011 15.9024C4.21506 15.9024 4.00011 16.1704 4.00011 16.501C4.00011 16.8315 4.21506 17.0996 4.48011 17.0996L15.5969 17.0996C15.7338 17.1103 15.8687 17.0537 15.9723 16.9418C16.076 16.8297 16.1402 16.6715 16.1514 16.501L16.1512 16.501Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.3081 11.1005C23.3084 10.7794 23.1063 10.5149 22.8497 10.5005L4.48008 10.5005C4.2149 10.5005 4.00008 10.7692 4.00008 11.1005C4.00008 11.4318 4.2149 11.7005 4.48008 11.7005L22.8497 11.7005C23.1063 11.6861 23.3084 11.4216 23.3081 11.1005V11.1005Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.75 2C2.16421 2 2.5 2.33579 2.5 2.75L2.5 21.25C2.5 21.6642 2.16421 22 1.75 22C1.33579 22 0.999999 21.6642 0.999999 21.25L1 2.75C1 2.33579 1.33579 2 1.75 2Z",
				fill: "var(--colors-grey-1)"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_410_6067",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(24) rotate(90)"
		})
	}) })]
});
export default SvgStackedBarChart;
